export const storeName = 'cartPage/products';
